export type AttendeeSummary =
  | { kind: "invitees"; names: string[] }
  | { kind: "onlyYou" }
  | { kind: "none" }

// Guests always win the summary, whichever event kind they were added to —
// a personal event that has gained guests must never keep reading "Only
// you". "Only you" is otherwise the personal-event default (no project
// team applies to it), and an appointment with nobody selected yet falls
// back to "none" rather than a claim about being private.
export function summarizeAttendees(
  eventKind: "appointment" | "reminder",
  invitees: string[],
  hasSelectedProject: boolean
): AttendeeSummary | null {
  if (invitees.length > 0) return { kind: "invitees", names: invitees }
  if (eventKind === "reminder") return { kind: "onlyYou" }
  if (hasSelectedProject) return { kind: "none" }
  return null
}
